export default function useCreateCoreLink(relativeUrl = '') {
    const url = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;

    return process.env.REACT_APP_POL_CORE_URL + url;
}
